export const buttonStyle = {
  marginLeft: "5px",
};

export const iconStyle = {
  height: "25px",
  width: "25px",
};

export const tableHeadingStyle = {
  paddingTop: "30px",
};

export const dialogWarningLabel = {
  background: "#eb4d2a",
  color: "white",
};

export const signalDialogCheckButton = {
  float: "right",
};
